import React, { useState } from 'react';
import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@quillbot/design-system';
import { RootState } from '@Common/models/redux/store';
import MyInputBox from 'src/_common/components/myInputBox/MyInputBox';
import { useSelector } from 'react-redux';
import { openToastr } from '@Common/handlers/services';
import LoadingSpinner from 'src/_common/quillElements/spinner/Loading';
import { isEmail } from 'core/utils';
import Track from '../handlers/track';
import Img from '../../_common/components/img';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heroSection: {
      borderBottom: '1px solid',
      backgroundColor: theme.palette.background.default,
      borderBottomColor: theme.palette.divider,
    },

    sectionMargin: {
      [theme.breakpoints.down('md')]: {
        marginBottom: '50px',
      },
    },
    br: {
      display: 'none',
      [theme.breakpoints.down(400)]: {
        display: 'block',
      },
    },
    addressSection: {
      maxWidth: '350px',
      padding: '40px 0',
      margin: 'auto',
      height: '100%',
      [theme.breakpoints.down('md')]: {
        maxWidth: '420px',
        padding: '40px 30px',
      },
    },
    textColor: {
      color: theme.palette.primary.contrastText,
    },
    quillbotImg: {
      position: 'absolute',
      bottom: '-25px',
      left: '10px',
      maxHeight: '300px',
      height: '23vw',
      [theme.breakpoints.down('md')]: {
        bottom: '-15px',
      },
    },
    rightSection: {
      backgroundColor: theme.palette.primary.main,
    },
    address: {
      color: theme.palette.primary.contrastText,
      maxWidth: '160px',
      paddingTop: '6px',
      paddingBottom: '8px',
      fontSize: '12px !important',
    },
    hoverUnderline: {
      color: theme.palette.primary.contrastText,
      '& :hover': {
        color: theme.palette.primary.contrastText,
        textDecoration: 'underline',
      },
    },

    contactHolderMain: {},

    contactHolder: {
      maxWidth: '450px',
      margin: 'auto',
      padding: '40px 0',
    },

    formHead: {
      textAlign: 'center',
    },
    qbpBb20: {
      paddingBottom: '20px',
    },
    messageBox: {
      '& div': {
        paddingLeft: '0px !important',
      },
    },
  })
);
function Contact() {
  const classes = useStyles();
  const [formSubmitted, updateFormSubmitted] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setLoading] = useState(false);
  const platform = useSelector((store: RootState) => store.common.platform);
  const isValidMessage = (str?: string) => str && /[a-zA-Z]/.exec(str);

  const setDefaultState = () => {
    updateFormSubmitted(false);
    setName('');
    setEmail('');
    setMessage('');
  };
  const sendInfo = () => {
    updateFormSubmitted(true);
    if (!isEmail(email) || !isValidMessage(message)) {
      return;
    }
    setLoading(true);
    /* Track.sendFeedback(name, email, message, () => {
      Zendesk.raiseTicket(name, email, message, () => {
        ParaModel.hideSpinner();
        // document.getElementById("message").value = "message sent :)";
        this.setState({ ...this.defaultFormState });
        ParaModel.showToastr("success", "Message sent.", 3000);
      });
    }); */
    Track.sendFeedback(name, email, message, () => {
      setLoading(false);
      openToastr('Message sent.', 3000);
      setDefaultState();
    });
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event?.target?.value;
    switch (event.target.name) {
      case 'name':
        setName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'message':
        setMessage(value);
        break;
      default:
        setMessage(value);
    }
    updateFormSubmitted(false);
  };
  // <Img src={QuillWrite}/>
  const { isMobile } = platform;
  let emailHelperText: string | null;
  if (formSubmitted) {
    if (!email) emailHelperText = 'Required';
    else if (!isEmail(email)) emailHelperText = 'Please enter valid email';
    else emailHelperText = null;
  } else {
    emailHelperText = null;
  }
  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <Grid container>
        <Grid item xs={12} className={classes.heroSection}>
          <h2 className="pageTitle" style={{ marginBottom: '30px' }}>
            How can we help?
          </h2>
        </Grid>
        <Grid item xs={12} style={{ position: 'relative' }}>
          <Grid container style={{ minHeight: '567px' }}>
            <Grid
              item
              sm={12}
              md={7}
              xs={12}
              className={classes.contactHolderMain}
              style={{ position: 'relative', padding: '0 15px' }}
            >
              <Grid
                container
                className={classes.contactHolder}
                justifyContent="center"
                alignItems="center"
              >
                <Grid
                  item
                  xs={12}
                  style={{ paddingBottom: '10px' }}
                  className=""
                >
                  <Typography color="textPrimary" display="block" gutterBottom>
                    Send us a message or question and we’ll help you as soon as
                    we can.
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: 'center' }}
                  className={classes.qbpBb20}
                >
                  <MyInputBox
                    variant="filled"
                    data-gramm_editor="false"
                    wt-ignore-input="true"
                    fullWidth
                    id="name"
                    name="name"
                    onChange={onChange}
                    size="small"
                    label="Name"
                    value={name}
                  />
                  {/* <textarea
                  data-gramm_editor="false"
                  id="name"
                  className="qbp-reg-input m-0"
                  placeholder="Name"
                /> */}
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ textAlign: 'center' }}
                  className={classes.qbpBb20}
                >
                  <MyInputBox
                    variant="filled"
                    data-gramm_editor="false"
                    wt-ignore-input="true"
                    fullWidth
                    onChange={onChange}
                    id="email"
                    error={formSubmitted && (!email || !isEmail(email))}
                    helperText={emailHelperText}
                    name="email"
                    size="small"
                    label="Email Address"
                    value={email}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: 'center' }}
                  className={classes.qbpBb20}
                >
                  <MyInputBox
                    variant="filled"
                    data-gramm_editor="false"
                    wt-ignore-input="true"
                    fullWidth
                    onChange={onChange}
                    name="message"
                    id="message"
                    helperText={
                      formSubmitted && !isValidMessage(message)
                        ? 'Required'
                        : null
                    }
                    error={formSubmitted && !isValidMessage(message)}
                    multiline
                    rows={4}
                    size="small"
                    label="Message"
                    value={message}
                    className={classes.messageBox}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    style={{ float: 'right' }}
                    variant="contained"
                    color="primary"
                    onClick={sendInfo}
                  >
                    {' '}
                    Send{' '}
                  </Button>
                </Grid>
              </Grid>
              {/* show quillbot bot in desktop  */}
              {isMobile ? null : (
                <Img
                  className={classes.quillbotImg}
                  src="/images/misc/quill_wave_old.png"
                  alt="quillbot"
                />
              )}
            </Grid>
            <Grid
              item
              sm={12}
              md={5}
              xs={12}
              style={{ zIndex: 1 }}
              className={classes.rightSection}
            >
              <Grid
                container
                className={classes.addressSection}
                style={{
                  margin: 'auto',
                  // color: 'white',
                  height: '100%',
                }}
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid
                  item
                  container
                  justifyContent="space-between"
                  className={classes.sectionMargin}
                  alignItems="center"
                >
                  <Grid item xs>
                    <Typography className={classes.textColor} display="block">
                      <b>CHICAGO</b>
                    </Typography>
                    <Typography className={classes.address} gutterBottom>
                      303 East Wacker, Suite 2101 Chicago, IL 60601 <br />{' '}
                      United States of America
                    </Typography>
                    <a
                      className={classes.hoverUnderline}
                      href="https://goo.gl/maps/i4NZaTaLkZtgTaqM7"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Map
                    </a>
                  </Grid>
                  <Grid item className="qbp-textCenter" xs>
                    <Img
                      style={{ marginLeft: '36px' }}
                      src="/images/city-Chicago.svg"
                      alt="Chicago icon"
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item xs>
                    <Typography className={classes.textColor} display="block">
                      <b>JAIPUR</b>
                    </Typography>
                    <Typography className={classes.address} gutterBottom>
                      3, Sahkar Marg, Behind IOC petrol pump, Jaipur-302001{' '}
                    </Typography>
                    <a
                      className={classes.hoverUnderline}
                      href="https://goo.gl/maps/9L8SBdawJ4XqpW3e9"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Map
                    </a>
                  </Grid>
                  <Grid item xs className="qbp-textCenter">
                    <Img
                      style={{ marginLeft: '36px' }}
                      src="/images/city-Jaipur.svg"
                      alt="Jaipur icon"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
export default Contact;
